<template>
  <WdsStack
    justify-space-between
    align-center
    class="tw-text-base tw-px-2.5 tw-py-3.5 tw-border tw-rounded"
  >
    <div>{{ $t('Rate') }}</div>
    <div>
      <WdsStack gap-sm>
        <template v-if="store.paymentRequestType === PaymentRequestTypeEnum.MILESTONE">
          <WdsTag v-if="showRateAndTypeFromHire" primary sm>
            {{ $t('Milestone') }}
          </WdsTag>
        </template>
        <template v-else>
          <WdsTag v-if="showRateAndTypeFromHire" primary sm>
            {{ store.currency }}
            {{ currencyJs(store.hireRate.rate, store.currencyConfig).format() }}
            {{ store.hireRate.rateTypeNameSlash }}
          </WdsTag>
          <WdsTag v-else primary sm>
            {{ store.currency }}
            {{ currencyJs(store.paymentRequestRate.rate, store.currencyConfig).format() }}
            {{ store.paymentRequestRate.rateTypeNameSlash }}
          </WdsTag>
          <template v-if="taxStore.allTaxLines.length">
            <WdsTag v-for="taxLine in taxStore.allTaxLines" :key="taxLine.terminology" sm>
              {{ taxLine.ratePercentage }}% {{ taxLine.terminology }}
            </WdsTag>
          </template>
        </template>
      </WdsStack>
    </div>
  </WdsStack>
</template>

<script lang="ts" setup>
import { WdsStack, WdsTag } from '@worksome/wds-components'
import currencyJs from 'currency.js'
import { computed } from 'vue'
import { usePaymentRequestStore } from '@/components/PaymentRequest/store/usePaymentRequestStore'
import { useTaxStore } from '@/components/PaymentRequest/store/useTaxStore'
import { useTranslation } from '@/composables/translation'
import { PaymentRequestTypeEnum } from './enums'

const { $t } = useTranslation()
const store = usePaymentRequestStore()
const taxStore = useTaxStore()

const showRateAndTypeFromHire = computed(() => {
  if (
    store.paymentRequestRate.rate !== store.hireRate.rate ||
    store.paymentRequestRate.rateType !== store.hireRate.rateType
  ) {
    // For fixed rate hire & bill, we still want to show the fixed rate
    // from the hire as reference
    if (store.paymentRequestRate.rateType === 'fixed' && store.hireRate.rateType === 'fixed') {
      return true
    }
    return false
  }
  return true
})
</script>
